import React from 'react';

const DayView = ({ 
  currentDate, 
  events, 
  onEventClick, 
  language 
}) => {
  const hours = Array.from({ length: 24 }, (_, i) => i);

  const getEventsForHour = (hour) => {
    const dateStr = currentDate?.toISOString()?.split('T')?.[0];
    return events?.filter(event => {
      if (event?.date !== dateStr) return false;
      const eventHour = parseInt(event?.time?.split(':')?.[0]);
      return eventHour === hour;
    });
  };

  const formatDate = () => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const locale = language === 'fr' ? 'fr-MA' : language === 'ar' ? 'ar-MA' : 'en-US';
    return currentDate?.toLocaleDateString(locale, options);
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-4 border-b border-border bg-muted/50">
        <h3 className="text-lg font-semibold text-foreground">{formatDate()}</h3>
      </div>
      <div className="max-h-[600px] overflow-y-auto">
        {hours?.map((hour) => {
          const hourEvents = getEventsForHour(hour);
          return (
            <div key={hour} className="flex border-b border-border min-h-[80px] hover:bg-muted/30 transition-colors">
              <div className="w-20 p-3 border-r border-border bg-muted/30 flex-shrink-0">
                <div className="text-sm font-medium text-muted-foreground">
                  {String(hour)?.padStart(2, '0')}:00
                </div>
              </div>
              <div className="flex-1 p-3">
                {hourEvents?.length > 0 ? (
                  <div className="space-y-2">
                    {hourEvents?.map((event) => (
                      <div
                        key={event?.id}
                        onClick={() => onEventClick(event)}
                        className={`p-3 rounded-lg cursor-pointer hover:opacity-90 transition-opacity ${
                          event?.type === 'hearing' ? 'bg-error/10 border border-error/20' :
                          event?.type === 'appointment' ? 'bg-primary/10 border border-primary/20' :
                          event?.type === 'deadline'? 'bg-warning/10 border border-warning/20' : 'bg-success/10 border border-success/20'
                        }`}
                      >
                        <div className="flex items-start justify-between gap-3">
                          <div className="flex-1 min-w-0">
                            <div className={`text-sm font-semibold mb-1 ${
                              event?.type === 'hearing' ? 'text-error' :
                              event?.type === 'appointment' ? 'text-primary' :
                              event?.type === 'deadline'? 'text-warning' : 'text-success'
                            }`}>
                              {event?.title}
                            </div>
                            <div className="text-xs text-muted-foreground">
                              {event?.time} - {event?.location}
                            </div>
                            {event?.participants && (
                              <div className="text-xs text-muted-foreground mt-1">
                                {event?.participants}
                              </div>
                            )}
                          </div>
                          <div className={`px-2 py-1 rounded text-xs font-medium ${
                            event?.type === 'hearing' ? 'bg-error text-error-foreground' :
                            event?.type === 'appointment' ? 'bg-primary text-primary-foreground' :
                            event?.type === 'deadline' ? 'bg-warning text-warning-foreground' :
                            'bg-success text-success-foreground'
                          }`}>
                            {event?.type === 'hearing' && (language === 'fr' ? 'Audience' : language === 'ar' ? 'جلسة' : 'Hearing')}
                            {event?.type === 'appointment' && (language === 'fr' ? 'RDV' : language === 'ar' ? 'موعد' : 'Appointment')}
                            {event?.type === 'deadline' && (language === 'fr' ? 'Échéance' : language === 'ar' ? 'موعد نهائي' : 'Deadline')}
                            {event?.type === 'meeting' && (language === 'fr' ? 'Réunion' : language === 'ar' ? 'اجتماع' : 'Meeting')}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-sm text-muted-foreground italic">
                    {language === 'fr' ? 'Aucun événement' : language === 'ar' ? 'لا توجد أحداث' : 'No events'}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DayView;